//
// Validator: REQUIREDIF
//
(function() {
    'use strict';
    var requiredIfValidatorName = 'requiredif',
        requiredIfDependsOnProperty = 'dependson',
        requiredIfTargetValueProperty = 'value';

    $.validator.addMethod(requiredIfValidatorName,
        function (value, element, parameters) {
            var name = parameters[requiredIfDependsOnProperty],
                targetvalue = parameters[requiredIfTargetValueProperty];

            var control = $(element).closest('form').find('[name="' + name + '"]');

            if (control.length > 1) {
                control = control.filter('input:checked').first();
            }

            var controltype = control.attr('type');
            var actualvalue = controltype === 'checkbox' || controltype === 'radio'
                                    ? (control.prop('checked') ? "True" : "False")
                                    : control.val();

            if (targetvalue === actualvalue) {
                return $.validator.methods.required.call(this, value, element, parameters);
            }

            return true;
        }
    );

    $.validator.unobtrusive.adapters.add(requiredIfValidatorName, [requiredIfDependsOnProperty, requiredIfTargetValueProperty],
        function(options) {
            var rules = {};
            rules[requiredIfDependsOnProperty] = options.params[requiredIfDependsOnProperty];
            rules[requiredIfTargetValueProperty] = options.params[requiredIfTargetValueProperty];
            options.rules[requiredIfValidatorName] = rules;
            options.messages[requiredIfValidatorName] = options.message;
        }
    );

    var requiredIfNotValidatorName = 'requiredifnot',
        requiredIfNotDependsOnProperty = 'dependson',
        requiredIfNotTargetValueProperty = 'value';


    $.validator.addMethod(requiredIfNotValidatorName,
        function (value, element, parameters) {
            var name = parameters[requiredIfNotDependsOnProperty],
                targetvalue = parameters[requiredIfNotTargetValueProperty];

            var control = $(element).closest('form').find('[name="' + name + '"]');

            if (control.length > 1) {
                control = control.filter('input:checked').first();
            }

            var controltype = control.attr('type');
            var actualvalue = controltype === 'checkbox' || controltype === 'radio'
                                    ? control.prop('checked').toString()
                                    : control.val();

            if (targetvalue !== actualvalue) {
                return $.validator.methods.required.call(this, value, element, parameters);
            }

            return true;
        }
    );

    $.validator.unobtrusive.adapters.add(requiredIfNotValidatorName, [requiredIfNotDependsOnProperty, requiredIfNotTargetValueProperty],
        function (options) {
            var rules = {};
            rules[requiredIfNotDependsOnProperty] = options.params[requiredIfNotDependsOnProperty];
            rules[requiredIfNotTargetValueProperty] = options.params[requiredIfNotTargetValueProperty];
            options.rules[requiredIfNotValidatorName] = rules;
            options.messages[requiredIfNotValidatorName] = options.message;
        }
    );

    $.validator.addMethod('requiredifmultiple',
        function (value, element, parameters) {

            var name = parameters['dependentproperty'];
            var control = $(element).closest('form').find('[name="' + name + '"]');

            if (control.length > 1) {
                control = control.filter('input:checked').first();
            }

            var controltype = control.attr('type');
            var actualvalue = controltype === 'checkbox' || controltype === 'radio'
                                ? (control.prop('checked') ? "True" : "False")
                                : control.val();

            // get the target value (as a string, 
            // as that's what actual value will be)
            var targetvalue = parameters['targetvalue'];
            targetvalue = (targetvalue == null ? '' : targetvalue).toString();

            var targetvaluearray = targetvalue.split('|');

            for (var i = 0; i < targetvaluearray.length; i++) {
                // if the condition is true, reuse the existing 
                // required field validator functionality
                if (targetvaluearray[i] === actualvalue) {
                    return $.validator.methods.required.call(this, value, element, parameters);
                }
            }

            return true;
        }
    );

    $.validator.unobtrusive.adapters.add(
        'requiredifmultiple',
        ['dependentproperty', 'targetvalue'],
        function (options) {
            options.rules['requiredifmultiple'] = {
                dependentproperty: options.params['dependentproperty'],
                targetvalue: options.params['targetvalue']
            };
            options.messages['requiredifmultiple'] = options.message;
        });

    $.validator.unobtrusive.adapters.add('dynamicrange', ['minvalueproperty', 'maxvalueproperty'],
       function (options) {
           var minValue = parseInt($('input[name="' + options.params['minvalueproperty'] + '"]').val(), 10);
           var maxValue = parseInt($('input[name="' + options.params['maxvalueproperty'] + '"]').val(), 10);
           if (isNaN(minValue)) { minValue = Number.MIN_VALUE; }
           if (isNaN(maxValue)) { maxValue = Number.MAX_VALUE; }
           var rules = {};
           rules['minvalueproperty'] = options.params['minvalueproperty'];
           rules['maxvalueproperty'] = options.params['maxvalueproperty'];
           options.rules['dynamicrange'] = rules;
           if (options.message != null) {
               var optionsMessage = options.message; //If max value if not defined (0) then show second message and validate only with min value.
               try {
                   optionsMessage = optionsMessage.split(';')[maxValue == 0 ? 1 : 0];
               } catch (e) {
               }

               options.messages['dynamicrange'] = $.format(optionsMessage, minValue, maxValue);
           }
       }
   );

    $.validator.addMethod('dynamicrange', function (value, element, params) {
        var minValue = parseInt($('input[name="' + params.minvalueproperty + '"]').val(), 10);
        var maxValue = parseInt($('input[name="' + params.maxvalueproperty + '"]').val(), 10);
        if (isNaN(minValue)) { minValue = Number.MIN_VALUE; }
        if (isNaN(maxValue)) { maxValue = Number.MAX_VALUE; }
        var currentValue = parseInt(value, 10);
        if (isNaN(currentValue) || minValue > currentValue || currentValue > maxValue && maxValue != 0) {
            return false;
        }
        return true;
    }, '');

    $.validator.unobtrusive.adapters.add('dynamicdaterange', ['minvalueproperty', 'maxvalueproperty'],
       function (options) {
           var minValue = Date.parse($('input[name="' + options.params['minvalueproperty'] + '"]').val());
           var maxValue = Date.parse($('input[name="' + options.params['maxvalueproperty'] + '"]').val());
           if (isNaN(minValue)) { minValue = new Date(-8640000000000000); }
           if (isNaN(maxValue)) { maxValue = new Date(8640000000000000); }
           var rules = {};
           rules['minvalueproperty'] = options.params['minvalueproperty'];
           rules['maxvalueproperty'] = options.params['maxvalueproperty'];
           options.rules['dynamicdaterange'] = rules;
           if (options.message != null) {
               var optionsMessage = options.message; //If max value if not defined (0) then show second message and validate only with min value.
               try {
                   optionsMessage = optionsMessage.split(';')[maxValue == 0 ? 1 : 0];
               } catch(e) {
               }

               options.messages['dynamicdaterange'] = $.format(optionsMessage, minValue, maxValue);
           }
       }
   );

    $.validator.unobtrusive.adapters.addBool("booleanrequired", "required");

    $.validator.addMethod('dynamicdaterange', function (value, element, params) {
        var minValue = Date.parse($('input[name="' + params.minvalueproperty + '"]').val());
        var maxValue = Date.parse($('input[name="' + params.maxvalueproperty + '"]').val());
        if (isNaN(minValue)) { minValue = new Date(-8640000000000000); }
        if (isNaN(maxValue)) { maxValue = new Date(8640000000000000); }
        var currentValue = Date.parse(value);
        if (minValue > currentValue || currentValue > maxValue && maxValue != new Date()) {
            return false;
        }
        return true;
    }, '');
})();

define("validation", ["unobtrusiveValidation"], function(){});

